import { Page } from '@app/components/page/Page';
import { AdminModule } from '@app/modules/admin';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { BreadcrumbItem } from '@mi-front/ui';
import compact from 'lodash/compact';
import { useIntl } from 'react-intl';

interface Props {
  platform?: SocialPlatform;
  items?: readonly BreadcrumbItem[];
}

export function SocialExportBreadcrumbs({ platform, items: extraItems = [] }: Props) {
  const { $t } = useIntl();

  const items = compact([
    ...(platform
      ? [
          {
            content: $t(
              {
                id: 'admin.socialExport.title',
                defaultMessage: 'Integración con {name}',
              },
              { name: platform.name },
            ),
            href: `/admin/social-export/${platform.id.toLowerCase()}`,
          },
        ]
      : []),
    ...extraItems,
  ]);

  return <Page.ModuleBreadcrumbs module={AdminModule} items={items} />;
}
